import React from 'react'
import {CardTitle} from 'reactstrap'

const cardTitle=(props)=>(<CardTitle {...props}/>)

export default cardTitle;